import moment from "moment"
import React from "react"
import { Badge, Card, Col, ListGroup, Row, Table } from "react-bootstrap"

export default function ProcedureSatuSehat({
    getProcedure,
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    🛠️ Daftar Prosedur Tindakan
                </Card.Header>

                {/* Scrollable wrapper */}
                <Card.Body className="p-0" style={{ height: '180px', overflowY: 'auto', overflowX: 'auto' }}>
                    <div style={{ minWidth: '600px' }}>
                        <Table bordered striped responsive size="sm" className="mb-0 small">
                            <thead className="table-light text-center">
                                <tr>
                                    <th>#</th>
                                    <th>📝 Nama Prosedur</th>
                                    <th>📄 Kode ICD-9</th>
                                    <th>📂 Kategori</th>
                                    <th>✅ Status</th>
                                    <th>⏰ Diperbarui</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getProcedure?.entry?.length > 0 ? (
                                    getProcedure.entry.map((item, index) => {
                                        const res = item.resource;
                                        return (
                                            <tr key={res.id || index}>
                                                <td className="text-center">{index + 1}</td>
                                                <td>{res.code?.coding?.[0]?.display || '-'}</td>
                                                <td>{res.code?.coding?.[0]?.code || '-'}</td>
                                                <td>{res.category?.coding?.[0]?.display || '-'}</td>
                                                <td className="text-center">
                                                    <Badge bg="info" className="text-uppercase small">
                                                        {res.status || '-'}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    {res.meta?.lastUpdated
                                                        ? moment(res.meta.lastUpdated).format('DD MMM YYYY, HH:mm')
                                                        : '-'}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            Tidak ada data prosedur
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}